<template>
  <section class="backStore">
    <pre>
      {{store}}
    </pre>
    <button @click="getStore">Get Store</button>
    <button @click="clearStore">Clear Store</button>
  </section>
</template>

<script>
export default {
  data() {
    return {
      store: null
    };
  },
  methods: {
    getStore() {
      this.$socket.emit("reqStore", null);
    },
    clearStore() {
      this.store = null;
    }
  },
  sockets: {
    resStore(data) {
      this.store = data;
    }
  }
};
</script>

<style>
</style>
